import { useEffect, useRef, useState } from "react";

// Pannello laterale variabili ridimensionabile orizzontalmente (trascina il bordo destro).
// Larghezza memorizzata in localStorage. Min 200px, max 500px.
export default function ResizableVarsPanel({
  children, className = "", storageKey = "pgp_vars_panel_w",
  defaultWidth = 256, min = 200, max = 500, testId, side = "right",
}) {
  const [width, setWidth] = useState(() => {
    const s = parseInt(localStorage.getItem(storageKey) || "", 10);
    return Number.isFinite(s) ? Math.min(max, Math.max(min, s)) : defaultWidth;
  });
  const start = useRef(null);

  useEffect(() => { localStorage.setItem(storageKey, String(width)); }, [width, storageKey]);

  useEffect(() => {
    const onMove = (e) => {
      if (!start.current) return;
      const dx = (e.clientX - start.current.x) * (side === "left" ? -1 : 1);
      setWidth(Math.min(max, Math.max(min, start.current.w + dx)));
    };
    const onUp = () => {
      if (!start.current) return;
      start.current = null;
      document.body.style.userSelect = "";
      document.body.style.cursor = "";
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => { window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
  }, [min, max, side]);

  const onDown = (e) => {
    e.preventDefault();
    start.current = { x: e.clientX, w: width };
    document.body.style.userSelect = "none";
    document.body.style.cursor = "col-resize";
  };

  return (
    <div className="relative shrink-0" style={{ width }} data-testid={testId}>
      <div className={className}>{children}</div>
      <div onMouseDown={onDown} data-testid={testId ? `${testId}-resize` : undefined}
        title="Trascina per ridimensionare"
        className={`absolute top-0 ${side === "left" ? "-left-1" : "-right-1"} h-full w-2 cursor-col-resize group flex items-center justify-center`}>
        <span className="h-10 w-1 rounded-full bg-slate-600 group-hover:bg-amber-500 transition-colors" />
      </div>
    </div>
  );
}
